import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { empModulo } from '../../../diccionarios/empModulo';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { LfsaBotonEditarGridComponent } from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import { ReportesService } from '../../../services/administrador/reportes.service';
import { EmpleadoModel } from '../../../models/empleadoModel';

@Component({
  selector: 'app-reportes-emp',
  templateUrl: './reportes-emp.component.html',
  styleUrls: ['./reportes-emp.component.css']
})
export class ReportesEmpComponent implements OnInit {
  EmpleadoMo
  resposiveFull: string;
  empModulo: any = {};
  formulario: FormGroup;//formulario
  loading: boolean = false;
  mostrarCard: boolean = true;
  // dataRequisicion: ResponseRequisicionModel;

  columnDefs: any[];//aggrid
  rowData: any[] = [];
  frameworkComponents: any;
  gridApi: any;
  gridColumnApi: any;
  rowSelection: any;
  listaVacia: boolean = true;
  textoBuscar: string;
  dataEdit: any = {};
  arrayEdit: any[] = [];

  constructor(private fb: FormBuilder, private _util: UtilsService, private _reporteService: ReportesService) { }

  ngOnInit() {
    this.empModulo = empModulo;
    this.resposiveFull = this.empModulo.div.resposiveFull;
    this.formulario = this.fb.group({
      numeroReuqisicion: ['', [Validators.required]],
      puntoReorden: ['', [Validators.required]],
    });
    this.cargarGrid();
    this.getDataRequisicion();
  }

  cargarGrid() {
    this.columnDefs = [
      {
        headerName: 'Cédula',
        field: 'cedula',
        filter: true,
        width: 180,
        cellStyle: this.changeCellColor.bind(this),
      },
      /*{
        headerName: 'ARTICULO',
        sortable: true,
        width: 180,
        filter: true,
        cellStyle: this.changeCellColor.bind(this),
        valueGetter: function (params) {
          // debugger
          let data = params.data;
          let seab = data.seab;
          let cntr = data.cntr;
          if(seab != undefined && seab != '' && cntr != undefined && cntr != ''){
            return seab + ' / ' + cntr;
          } else {
            if(cntr != undefined && cntr != ''){
              return seab + ' / ' + cntr;
            } else {
              return seab;
            }
          }
         
        }
      },*/
      {
        headerName: 'Tipo Empleado',
        field: 'tipoEmpleado',
        filter: true,
        width: 150,
        cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Nombres',
        field: 'nombres',
        sortable: true,
        filter: true,
        width: 260,
        cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Dirección',
        field: 'direccion',
        sortable: true,
        filter: true,
        width: 280,
        cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Dirección Domicilio',
        field: 'direccionDomicilio',
        sortable: true,
        filter: 280,
        cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'País Nacimiento',
        field: 'paisNacimiento',
        sortable: true,
        filter: 180,
        cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Provincia Nacimiento',
        field: 'provinciaNacimiento',
        sortable: true,
        filter: 180,
        cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Región Domicilio',
        field: 'regionDomicilio',
        sortable: true,
        filter: 180,
        cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Género',
        field: 'genero',
        sortable: true,
        filter: 180,
        cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'e-mail',
        field: 'email',
        sortable: true,
        filter: 180,
        cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Fecha Nacimiento',
        field: 'fechaNacimiento',
        sortable: true,
        filter: 180,
        cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Fecha primer contrato',
        field: 'fechaPrimerContrato',
        sortable: true,
        filter: 180,
        cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Fecha último contrato',
        field: 'fechaUltimoContrato',
        sortable: true,
        filter: 180,
        cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Fecha Ingreso',
        field: 'fechaIngreso',
        sortable: true,
        filter: 180,
        cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Fecha Salida',
        field: 'fechaSalida',
        sortable: true,
        filter: 180,
        cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Código Empresa',
        field: 'empresa.codEmpresa',
        sortable: true,
        filter: 180,
        cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Empresa Descripción',
        field: 'empresa.descripcion',
        sortable: true,
        filter: 180,
        cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Código Costo',
        field: 'codCCosto',
        sortable: true,
        filter: 180,
        cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Descripcón Costo',
        field: 'dscaCCosto',
        sortable: true,
        filter: 180,
        cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Código Cargo',
        field: 'codCargo',
        sortable: true,
        filter: 180,
        cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Descripción Cargo',
        field: 'dscaCargo',
        sortable: true,
        filter: 180,
        cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Código Departamento',
        field: 'codDepartamento',
        sortable: true,
        filter: 180,
        cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Descripción Departamento',
        field: 'dscaDepartamento',
        sortable: true,
        filter: 180,
        cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Código localidad',
        field: 'codLocalidad',
        sortable: true,
        filter: 180,
        cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Descripción Localidad',
        field: 'dscaLocalidad',
        sortable: true,
        filter: 180,
        cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Reparta A',
        field: 'reportaA',
        sortable: true,
        filter: 180,
        cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Estatus Empleado',
        field: 'statusEmpleado',
        sortable: true,
        filter: 180,
        cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Empresa solicitante',
        field: 'empresaSolicita',
        sortable: true,
        filter: 180,
        cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Deapartamento solcitante',
        field: 'departamentoSolicitaDsca',
        sortable: true,
        filter: 180,
        cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Empleado solicitante',
        field: 'empleadoSolicitaDsca',
        sortable: true,
        filter: 280,
        cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Realizó Cambio',
        field: 'userChangeBy',
        sortable: true,
        filter: 280,
        cellStyle: this.changeCellColor.bind(this),
      },
    ];

    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };

    this.rowSelection = 'multiple';
  }

  changeCellColor(params) {
    let data = params.data;
    if (data.info != undefined) {
      if (data.info === 'false') {
        return {
          'background-color': '#FFC0CB',
          'color': 'black',
          'font-weight': 'bold',
          'font-size': '14px'
        };
      }
    }
    return false;
  }

  changeRowColor(params) {
    let data = params.data;
    if (data.modificado != undefined) {
      if (data.modificado === true) {
        return {
          'background-color': 'yellow',
          'color': 'black',
          'font-weight': 'bold',
          'font-size': '14px'
        };
      }
    }
    return false;
  }

  onQuickFilterChanged() {
    this.gridApi.setQuickFilter(this.textoBuscar);
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  getDataRequisicion() {
    this.loading = true;
    let cedula = this.formulario.get('numeroReuqisicion').value;
    this._reporteService.getReportEmpleados().subscribe((res: EmpleadoModel[]) => {
      console.log(res);
      this.loading = false;
      this.rowData = res;
      if (this.rowData.length > 0) {
        this.listaVacia = false;
        this.rowData = this.addSecuencial();
      } else {
        this.listaVacia = true;
      }
    }, (err) => {
      console.log(err);
      this.loading = false;
      this.rowData = [];
      this.listaVacia = true;
      this._util.mensajeErrorVisto(err.error.message);
    });
  }

  addSecuencial() {
    let conunt = 0;
    let arraSecuencial = [];
    arraSecuencial = this.rowData.map((e)=>{
      e.secuencial = conunt++;
      return e;
    });
    return arraSecuencial;
  }

  callModal({ rowData }) {
    this.dataEdit = rowData;
    this.formulario.get('puntoReorden').setValue(rowData.puntoReorden);
    document.getElementById('abrirModal').click();
  }

  updatePuntoReorden() {
    let puntoReorden = this.formulario.get('puntoReorden').value;
    this.dataEdit.puntoReorden = puntoReorden;
    this.dataEdit.modificado = true;
    let sec = this.dataEdit.secuencial;
    const index = this.rowData.findIndex((e) => e.secuencial === sec);
    this.rowData.splice(index, 1, this.dataEdit);
    this.gridApi.setRowData(this.rowData);
    this.dataEdit = {};
    document.getElementById("cerrarModal").click();
  }

  downloadEmpleadosExcel() {
    this.loading = true;
    this._reporteService.getReporteEmpleadosExcel().subscribe((res: any) => {
      this.loading = false;
      this._util.descargarArchivo(res.clave, res.valor);
    }, (err) => {
      console.log(err);
      this.loading = false;
      this._util.mensajeErrorVisto(err.error.message);
    });
  }
}
